'use strict';

import React from 'react';

const PageView = (props) => {
    const linkClassName = props.pageLinkClassName;
    let cssClassName = props.pageClassName;
    const onClick = props.onClick;

    if (props.selected) {
        if (typeof(cssClassName) !== 'undefined') {
            cssClassName = cssClassName + ' ' + props.activeClassName;
        } else {
            cssClassName = props.activeClassName;
        }
    }

    return (
        <li onClick={onClick} className={cssClassName}>
            <a className={linkClassName}>
                {props.page}
            </a>
        </li>
    );
};

PageView.PropTypes = {
    page: React.PropTypes.number,
    pageLinkClassName: React.PropTypes.string,
    pageClassName: React.PropTypes.string,
    activeClassName: React.PropTypes.string,
    selected: React.PropTypes.number,
    onClick: React.PropTypes.func.isRequired
};

export default PageView;



/** WEBPACK FOOTER **
 ** ./src/components/pagination/PageView.jsx
 **/